import * as yup from "yup";

export enum MemoESignatureDrawerSteps {
  WARNING_MESSAGE = "warning_message",
  ROLES_AND_CONTACTS = "roles_and_contacts",
  NOTIFICATION_EMAIL = "notification_email",
  REVIEW_AND_SEND = "review_and_send",
  TRACK_E_SIGN_PROCESS = "track_e_sign_process",
}

export enum MemoESignatureAssigneeDrawerActionType {
  ADD = "add",
  REMOVE = "remove",
  REPLACE = "replace",
}

export enum MemoSignatureStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  APPLIED = "APPLIED",
  OUTDATED = "OUTDATED",
  REJECTED = "REJECTED",
  TERMINATED = "TERMINATED",
}

export const MemoSignatureStatusMapping = {
  DRAFT: "signature collected",
};

export const VALIDATION_SCHEMA = yup.object({
  days_interval_time: yup
    .number()
    .positive()
    .required("This field is required."),
  custom_text_appendix: yup.string().nullable(),
});

export interface INotificationEmailValues {
  custom_text_appendix: string;
  days_interval_time: number;
  reminders_enabled: boolean;
}

export const INITIAL_VALUES = {
  custom_text_appendix: "",
  days_interval_time: 3,
  reminders_enabled: true,
};

export const INTERVAL_TIME_OPTIONS = Array.from({ length: 7 }, (_, i) => ({
  label: (i + 1).toString(),
  value: (i + 1).toString(),
}));
